import { EmissorOrderScreenStatus } from '../../types/emissor-order-history';
const NON_INVOICE_PRODUCT_CODES = new Set(['MOBILITY', 'HOME_OFFICE', 'FUEL', 'HEALTH', 'EDUCATION', 'REWARD']);
export function resolveInvoiceCardState({ screenStatus, productCode, taxInvoiceId, }) {
    if (screenStatus === EmissorOrderScreenStatus.CANCELLED) {
        return 'hidden';
    }
    if (NON_INVOICE_PRODUCT_CODES.has(productCode?.trim().toUpperCase() ?? '')) {
        return 'unavailable';
    }
    return taxInvoiceId?.trim() ? 'available' : 'awaiting';
}
